import ChatBotApiService from './chatbot-api.service';
import GlobalStoreService from "./global-store.service";
import GLOBAL_CONFIG from '../config/config';
import BotType from '../enums/BotType';
import TrackingMiddlewareService from './tracking-middleware.service';
import TrackingKey from '../enums/trackingKey'
import UtilService from './util.service';
import TrackingPlatform from '../enums/TrackingPlatform';

export default class InitializeChatBotService {

    static getBasicTokenAndInitializeChatBotData() {

        // console.log('get param value for lob', UtilService.getParamValue('lob'))


        if (UtilService.getParamValue('lob') === 'paymentsbank' && GlobalStoreService.get('APP_CONTEXT')) {
            //current bot type is payments bank
            // console.log('bot type-- payments bank')
            GlobalStoreService.set('currentBotType', BotType.PAYMENTS_BANK)
        }


        return new Promise((resolve, reject) => {
            ChatBotApiService.getChatToken().then((result) => {

                if (GLOBAL_CONFIG.env !== "local") {
                    GlobalStoreService.set("basicToken", "Bearer" + result.access_token);
                } else {
                    GlobalStoreService.set("basicToken", "Bearer" + result.access_token);
                    GlobalStoreService.set("isUserLoggedIn", true);
                    GlobalStoreService.set("primaryNumber", "");
                    GlobalStoreService.set("currentNumber", "");
                    // GlobalStoreService.set('currentBotType', BotType.PREPAID)
                    // GlobalStoreService.set("userProfile", GLOBAL_CONFIG.userProfileFor)
                    // let numbers = UtilService.getUserProfileNumbersWithAccountType(GLOBAL_CONFIG.userProfileFor);
                    // GlobalStoreService.set("userAccounts", numbers);

                    // GlobalStoreService.set("loggedInToken", "Bearer   " + GLOBAL_CONFIG.tokenFor);
                }
                //fetch categories
                this.getInitialOptionsCategories();

            }).then(() => {
                //get default scenarios for the current bot type
                this.getDefaultScenariosPromise(GlobalStoreService.get('currentBotType')).then(
                    result => {
                        resolve();
                    },
                    error => {
                        TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_BACKEND)
                        reject();
                    }
                )
            }).then(() => {

                if (GlobalStoreService.get('currentBotType') !== BotType.PAYMENTS_BANK) {
                    //get default scenarios for any other bot type remaining 
                    Object.keys(BotType).filter(type => typeof (BotType[type]) === 'string').map((botTypeKey) => {

                        if (BotType[botTypeKey] !== GlobalStoreService.get('currentBotType') && BotType[botTypeKey] !== BotType.PAYMENTS_BANK) {

                            this.getDefaultScenariosPromise(BotType[botTypeKey]).then(
                                result => {
                                    // console.log('got default scenarios for', botTypeKey)
                                },
                                error => {
                                    // console.log('default scenarios rejected -- error case', error)
                                    TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_BACKEND)
                                }
                            )
                        }
                    })
                }
            }).catch((error) => {

                reject();
            })
        })

    }

    static getDefaultScenariosPromise(botType) {
        return new Promise((resolve, reject) => {
            ChatBotApiService.getBotTypeDefaultScenarios(botType).then(
                response => {
                    resolve();
                    let scenarioListStoreData = GlobalStoreService.get("scenarioList");
                    scenarioListStoreData[botType] = response
                    GlobalStoreService.set("scenarioList", scenarioListStoreData);
                },
                (error) => {
                    reject(error);
                });
        })
    }

    static getInitialOptionsCategories() {
        // console.log('fetch categories')
        if (!GlobalStoreService.get('categoriesFetched')[BotType[GlobalStoreService.get('currentBotType')]]) {
            ChatBotApiService.getOptionsCategories().then(
                res => {
                    GlobalStoreService.set("categoriesFetched", { ...GlobalStoreService.get('categoriesFetched'), [BotType[GlobalStoreService.get('currentBotType')]]: res })
                },
                err => {
                    // console.log(err) 
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/initialize-chatbot-data.service.js